export function modeBanner() {
  return (
    <>
      {import.meta.env.DEV && <div className="bg-red-500 text-white p-4 text-center font-bold">DEVELOPMENT MODE</div>}
    </>
  );
}